module.exports = __webpack_public_path__ + "static/img/avatar.dda6fd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar.png
// module id = 40
// module chunks = 2